import React, { useState } from "react";
import { format, addDays } from "date-fns";
import CommonFilterStructure from "../common-components/CommonFilterStructure";

const PaymentLinkFilters = ({
  decryptedText,
  allPaymentOnlineData,
  allPaymentCashData,
  paymentTableFilters,
  setPaymentFilters,
  onClickSearch,
  searchFilterApplied,
  onClickReset,
  isLoading,
  isReload
}) => {
  const [openDateRanger, setOpenDateRanger] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setPaymentFilters({
      ...paymentTableFilters,
      selectedStartDate: formattedStartDate,
      selectedEndDate: formattedEndDate,
    });
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setPaymentFilters({
      ...paymentTableFilters,
      selectedStartDate: "",
      selectedEndDate: "",
    });
  };

  return (
    <CommonFilterStructure
      from="payment-link"
      decryptedText={decryptedText}
      setFilters={setPaymentFilters}
      filters={paymentTableFilters}
      searchFilterApplied={searchFilterApplied}
      onClickSearch={onClickSearch}
      allPaymentOnlineData={allPaymentOnlineData}
      allPaymentCashData={allPaymentCashData}
      onClickReset={onClickReset}
      openDateRanger={openDateRanger}
      handleDateRangeChange={handleDateRangeChange}
      setOpenDateRanger={setOpenDateRanger}
      rangeState={rangeState}
      clearDateRanger={clearDateRanger}
      isLoading={isLoading}
      isReload={isReload}
    />
  );
};

export default PaymentLinkFilters;
